import { createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: {
        items: [],
        unreadCount: 0
    },
    reducers: {
        addNotification: (state, action) => {
            state.items.unshift(action.payload);
            state.unreadCount += 1;
        },
        setNotifications: (state, action) => {
            state.items = action.payload?.items || [];
            state.unreadCount = action.payload?.unreadCount ?? 0;
        },
        markOneRead: (state, action) => {
            const id = action.payload;
            const idx = state.items.findIndex(n => n.id === id);
            if (idx === -1) return;
            if (!state.items[idx].isRead) {
                state.unreadCount = Math.max(0, state.unreadCount - 1);
            }
            state.items[idx].isRead = true;
        },
        markAllRead: (state) => {
            state.items = state.items.map(n => ({ ...n, isRead: true }));
            state.unreadCount = 0;
        },
        clearNotifications: (state) => {
            state.items = [];
            state.unreadCount = 0;
        }
    }
});

export const { addNotification, setNotifications, markOneRead, markAllRead, clearNotifications } = notificationsSlice.actions;
export default notificationsSlice.reducer;
